import axiosInstance from "./baseUrl";

export const createAdmin = async (signUpData: any) => {
  // Remove null, undefined, and empty string values
  const filteredData = Object.entries(signUpData).reduce(
    (acc: any, [key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        acc[key] = value;
      }
      return acc;
    },
    {},
  );

  const response = await axiosInstance.post(
    "/v1/auth/create_admin",
    filteredData,
  );
  return response.data;
};

export const getUsers = async (parameters: any) => {
  const response = await axiosInstance.get("/v1/auth/get_users", {
    params: parameters,
  });
  return response.data;
};

export const getReferredUsers = async (parameters: any) => {
  const response = await axiosInstance.get("/v1/auth/view_all_referrals", {
    params: parameters,
  });
  return response.data;
};

export const getRoles = async () => {
  const response = await axiosInstance.get("/v1/auth/roles");
  return response.data;
};

export const getAdminProfile = async () => {
  const response = await axiosInstance.get("/v1/auth/user_profile");
  return response.data;
};

export const updateAdminProfile = async (parameters: any) => {
  const response = await axiosInstance.put(
    "/v1/auth/update_profile",
    parameters,
  );
  return response.data;
};
export const updateUserProfile = async (parameters: any) => {
  const response = await axiosInstance.put("/v1/auth/update_user", parameters);
  return response.data;
};

export const disableAgent = async (id: any) => {
  const response = await axiosInstance.put(
    `/v1/currier/disable_courier_agent/${id}`,
  );
  return response.data;
};
export const disableAdmin = async (id: any) => {
  const response = await axiosInstance.put(`/v1/auth/disable-admin/${id}`);
  return response.data;
};

export const disableVendor = async (vendorId: string) => {
  const response = await axiosInstance.put(
    `/v1/auth/disable-vendor/${vendorId}`,
  );
  return response.data;
};

export const enableVendor = async (vendorId: string) => {
  const response = await axiosInstance.put(
    `/v1/auth/enable-vendor/${vendorId}`,
  );
  return response.data;
};

export const getUserById = async (userId: string) => {
  const response = await axiosInstance.get(`/v1/auth/${userId}/retrieve`);
  return response.data;
};

export const deleteUser = async (userId: string) => {
  const response = await axiosInstance.delete(`/v1/auth/delete/${userId}`);
  return response.data;
};

export const changePassword = async (parameters: any) => {
  const response = await axiosInstance.post(
    "v1/auth/reset_password",
    parameters,
  );
  return response.data;
};
